import React, { useEffect } from "react";
import { Flex } from "./Flex";
import { PageSideMenu } from "./PageSideMenu";
import { SubHeader, SubHeaderProps } from "./SubHeader";
import styled from "styled-components";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useNavigate, useParams } from "react-router-dom";
import { Breakpoints } from "../theme/Breakpoints";
import { Spacing } from "../theme/Spacing";

const Container = styled(Flex)`
  flex-direction: column;
  margin-inline-start: auto;
  overflow-y: auto;
  /* 18rem = the width of the side menu */
  width: calc(100% - 18rem);
  padding-bottom: ${Spacing.xxxl};

  @media (max-width: ${Breakpoints.DESKTOP}) {
    /* 4rem = the width of the side menu */
    width: calc(100% - 4rem);
  }
`;

type PageWithSideMenuProps = {
  sections: {
    section: React.ReactNode;
    link: string;
    title: string;
    icon: IconProp;
    hide?: boolean;
  }[];
  subheaderProps: SubHeaderProps;
};

export const PageWithSideMenu: React.FC<PageWithSideMenuProps> = ({
  sections = [],
  subheaderProps,
}) => {
  const { section } = useParams();
  const navigate = useNavigate();

  const visibleSections = sections.filter((s) => !s.hide);

  useEffect(() => {
    const currentSection = visibleSections.find(
      (s) => s.link.split("/")[2] === section,
    );

    if (!currentSection) {
      const firstSectionRoute = visibleSections[0]?.link;

      if (firstSectionRoute) {
        navigate(firstSectionRoute, { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    }
  }, [navigate, visibleSections, section]);

  return (
    <Flex flex={1} overflow="hidden">
      <PageSideMenu
        links={sections
          .filter((section) => !section?.hide)
          .map(({ section, hide, ...rest }) => rest)}
      />

      <Container>
        <SubHeader {...subheaderProps} removeSideShadow />

        {sections?.find(
          (sect) => !sect?.hide && sect.link.split("/")[2] === section,
        )?.section || null}
      </Container>
    </Flex>
  );
};
